import { IResourceByType, IResourceStackRecord } from '@/dto/operationalPlanSummary';
import { OperationalDayName } from './OperationalDayName';

export class ResourceStackRecord {
    public static fromDto(dto: IResourceStackRecord): ResourceStackRecord {

        if (!dto) { throw new Error('dto is not set'); }

        const operDayName = OperationalDayName.fromDto(dto.operDayName);

        const result = new ResourceStackRecord(operDayName, dto.resourcesByType);

        return result;
    }

    public readonly operDayName: OperationalDayName;
    public readonly resourcesByType: IResourceByType[];

    constructor(operDayName: OperationalDayName, resourcesByType: IResourceByType[]) {
        this.operDayName = operDayName;
        this.resourcesByType = resourcesByType;
    }
}
